/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions
 */
export interface FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions
     */
    DefaultPlacementId: string;
}

/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementFbInstantInterstitialOptions(value: object): value is FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions {
    if (!('DefaultPlacementId' in value) || value['DefaultPlacementId'] === undefined) return false;
    return true;
}

export function FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsFromJSON(json: any): FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions {
    return FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'DefaultPlacementId': json['DefaultPlacementId'],
    };
}

export function FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsToJSON(json: any): FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions {
    return FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementFbInstantInterstitialOptionsToJSONTyped(value?: FxIdDomainSettingsAdvertisementFbInstantInterstitialOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'DefaultPlacementId': value['DefaultPlacementId'],
    };
}

